import AboutLeftTab from './AboutLeftTab'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'


const JNTUHApprovals = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    JNTUH Approvals
                                </h2>
                                <div class="detgails-right-content">
                                    <div class="related-download bg-gray">
                                        <ul>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/recognitions/JNTUH_AFFILIATION_2024-2025.pdf" target="_blank">
                                                    <i class="fa-solid fa-file-pdf"></i> JNTUH Affiliation 2024–2025
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/recognitions/JNTUH_AFFILIATION_2023-2024.pdf" target="_blank">
                                                    <i class="fa-solid fa-file-pdf"></i> JNTUH Affiliation 2023–2024
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/recognitions/JNTUH_AFFILIATION_2022-2023.pdf" target="_blank">
                                                    <i class="fa-solid fa-file-pdf"></i> JNTUH Affiliation 2022–2023
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/recognitions/JNTUH_AFFILIATION_2021-2022.pdf" target="_blank">
                                                    <i class="fa-solid fa-file-pdf"></i> JNTUH Affiliation 2021–2022
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default JNTUHApprovals
